import React, { useEffect, useState, useRef } from "react";
import SplitOrder from "./TabsComponents/SplitOrder";
import SumTable from "./SumTables/SumTable";
import Orderlogs from "./TabsComponents/Orderlogs";
import Transaction from "./TabsComponents/Transaction";
import Comments from "./TabsComponents/Comments";
import UIkit from "uikit";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

import EditModal from "./Modals/EditModal";
import { useForm } from "react-hook-form";
import Documents from "./TabsComponents/Documents";
import axios from "axios";
import Constants from "../../../utils/Constants";
import pbo from "../../../assets/images/byd-mega-motor-logo-white.png";
import { DecryptData } from "../../../utils/Cipher";
import CompleteModal from "./Modals/CompleteModal";
import InvoiceModal from "./Modals/InvoiceModal";
import InvoiceShow from "./Modals/InvoiceShow";
import { usePermissions } from "../../../context/PermissionsContext";
import Swal from "sweetalert2";




const Dropdown = ({ data, closeFunc, refetch, summaryrefetch, invoiceInfo , Apiendpoint }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const {Permissions} = usePermissions();
  

  const [loader, setLoader] = useState(false);
  const [isDelivered, setisDelivered] = useState(data.paymentStatus === 'delivered'  || data.paymentStatus === 'cancelled' ? true : false);
  const [Tentativedate, setTentativedate] = useState(false)
  const [PreviewPBOForm, setPreviewPBOForm] = useState(false)
  const user = DecryptData();


  // console.log( data.details.customerInfo , 'musfar test cust info' )

  const [customerData, setCustomerData] = useState(data.details.customerInfo);

  const [pboData, setPbo] = useState();
  const [showspace, setShowspace] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [features, setFeatures] = useState({
    freeService: false,
    chargingCoupons: false,
    chargerInstallation: false,
    extendedWarranty: false,
    atto2LimitedOffer: false,
    sealion7LimitedOffer: false
  });
  const [bankdata, setbankdata] = useState([]);
  const [invoiceType, setInvoiceType] = useState(null); // 'final' | 'full'
  const contentRef = useRef();




  // for  checking if pbo,bank_slip is already generated. if so then buttons are disabled 

  const hasPboDocument = data.orderPaymentDocuments.some(doc => doc.documentType === 'pbo');
  const hasFullPaymentSlipDocument = data.orderPaymentDocuments.some(doc => doc.documentType === 'final_bank_slip');
  const hasInvoiceDocument = data.orderPaymentDocuments.some(doc => doc.documentType === 'second_bank_slip');



  const numberToWords = (num) => {
    const ones = [
      "", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine",
      "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen",
      "seventeen", "eighteen", "nineteen"
    ];
    const tens = ["", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];

    const convertHundreds = (num) => {
      let result = "";
      if (num >= 100) {
        result += ones[Math.floor(num / 100)] + " hundred ";
        num = num % 100;
      }
      if (num >= 20) {
        result += tens[Math.floor(num / 10)] + " ";
        num = num % 10;
      }
      if (num > 0) {
        result += ones[num];
      }
      return result.trim();
    };

    if (num === 0) return "zero";

    let result = "";

    if (num >= 1000000000) {
      result += convertHundreds(Math.floor(num / 1000000000)) + " billion ";
      num = num % 1000000000;
    }
    if (num >= 1000000) {
      result += convertHundreds(Math.floor(num / 1000000)) + " million ";
      num = num % 1000000;
    }
    if (num >= 1000) {
      result += convertHundreds(Math.floor(num / 1000)) + " thousand ";
      num = num % 1000;
    }

    result += convertHundreds(num);
    return result.trim();
  };


 


  const openModal = () => {
    UIkit.modal("#details").show();
  };

  const Submit = (value) => {
    setLoader(true);

    // debugger;
    axios({
      method: "patch",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      // data: data,
      data: { orderId: data.id, update_status: value.update_status, remarks: value.remarks },
      url: Constants.url + `orders/update-status`,
    })
      .then((res) => {
        setLoader(false);

        if (res.data.status === "success") {
          UIkit.modal("#update_status").hide()
          window
            .swal({
              icon: "success",
              title: "success",
            }).then(() => summaryrefetch());

          refetch()
        }

      })
      .catch((err) => {
        UIkit.modal("#update_status").hide()
        window
          .swal({
            icon: "error",
            title: "Error",
            text: err.response.data.message
          })
        setLoader(false);
      });
  };


  // const openModal = () => {
  //   UIkit.modal("#details").show();
  // };



  //to send in prop of update modal 
  const customer = data.details.customerInfo;

  const openUpdateStatusModal = () => {
    UIkit.modal("#update_status").show();
  };
  // const openDateSelectorModal = () => {
  //   UIkit.modal("#date-selector").show();
  // };
  const openPdf = () => {


    refetch().then(() => 
    {
    
      if (data.transaction.length === 0) {
        window.swal({
          icon: 'error',
          title: 'Transaction Data Not Found'
        })
      } else {
        UIkit.modal("#modal-media-image").show();
      }
    }
    )


    //getPBODetails()
  };

  const transactionAmount = () => {
    const transactions = data.transaction
    // only the paid Transactions amount will be added to sum table
    const transaction_amount = transactions.map((item) => item.status === 'Paid' ? item.amount : 0);
    const totaltransactionAmount = transaction_amount.reduce((accumulator, currentAmount) => {
      return parseInt(accumulator) + parseInt(currentAmount);
    }, 0);

    return totaltransactionAmount;
  }

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  
  const handleFeatureChange = (featureName) => (event) => {
    setFeatures(prev => ({
      ...prev,
      [featureName]: event.target.checked
    }));
  };

  const clickToViewPreviewPBOForm = () => {
    if(Tentativedate){
      setPreviewPBOForm(true);
    }else{
      window.swal({
        icon: 'error',
        title: 'Please Select Tentative Date to Preview BPO Form'
      })
    }
  }

  const generateMultiPagePDF = async () => {
    setShowspace(true);
    const content = contentRef.current;

    // Delay the rendering to avoid UI blocking
    setTimeout(async () => {
      try {

        const pdf = new jsPDF('p', 'mm', 'a4'); // Initialize jsPDF for A4 size in portrait mode
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // Capture the HTML content using html2canvas with reduced scale for optimization
        const canvas = await html2canvas(content, {
          scale: 2,  // Lower scale if necessary for optimization
          useCORS: true,  // Allow CORS images to be included
        });

        // Convert the canvas to JPEG image data (JPEG reduces size better than PNG)
        const imgData = canvas.toDataURL('image/jpeg', 0.75);  // Reduce quality slightly (0.75)

        // Calculate the image height based on canvas dimensions
        const imgHeight = (canvas.height * pageWidth) / canvas.width; // Scale image to fit page width

        let heightLeft = imgHeight;
        let position = 0;
        let pageNumber = 1;

        // Add the first page
        pdf.addImage(imgData, 'JPEG', 0, position, pageWidth, imgHeight, undefined, 'FAST'); // 'FAST' compression
        pdf.setFontSize(10);
        pdf.setFontSize(6);
        pdf.text(`Page ${pageNumber} of 2`, pageWidth - 20, pageHeight - 10); // Add page number at bottom-right
        heightLeft -= pageHeight; // Adjust for next page
        pageNumber++;

        // Handle content longer than one page
        while (heightLeft > 0) {
          position = heightLeft - imgHeight; // Adjust position for remaining content
          pdf.addPage();
          pdf.addImage(imgData, 'JPEG', 0, position, pageWidth, imgHeight, undefined, 'FAST');
          pdf.setFontSize(6);
          pdf.text(`Page ${pageNumber} of 2`, pageWidth - 20, pageHeight - 10); // Add page number for this page
          heightLeft -= pageHeight;
          pageNumber++;
        }

        // Compress output to reduce file size (Blob option)
        const pdfBlob = pdf.output('blob');

        // Check file size and reduce if necessary
        if (pdfBlob.size > 5 * 1024 * 1024) {
          alert('File size exceeds 5MB. Further compression is needed.');
        } else {
          // You can send the blob to your API here
          pdf.save('PBO_' + data.id + ' ' + new Date().toLocaleString() + '.pdf');
          setShowspace(false);

          // Convert the PDF to a Blob
          //const pdfBlob = pdf.output('blob');
          // Send the PDF Blob to an API
          const formData = new FormData();
          formData.append('pbo', pdfBlob, 'PBO_' + data.id + ' ' + new Date().toLocaleString() + '.pdf');
          SubmitPBO(formData);
        }

      } catch (error) {
      }
    }, 100);  // Delay to keep UI responsive
  };






  const SubmitPBO = (value) => {

    setLoader(true);

    axios({
      method: "patch",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      // data: data,
      data: value,
      url: Constants.url + `orders/${data.id}/pbo`,
    })
      .then((res) => {
        setLoader(false);
        if (res.data.status === "success") {
          SentPBOEmail();
          refetch()
        }
      })
      .catch((err) => {
        setLoader(false);
      });


      const date = new Date(Tentativedate);
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // Months are 0-indexed



    // Api For Delivery Date 
    axios({
      method: "POST",
      data:{
        deliveryDate:`${year}-${month}-1`,
        charger : isChecked
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      
      url: Constants.url + `orders/${data.id}/save-delivery-date`,
    })
      .catch((err) => {
        console.log(err)
      });
  };

  const SentPBOEmail = () => {

    setLoader(true);

    axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      // data: data,
      // data: value,
      url: Constants.url + `orders/${data.id}/send-pbo`,
    })
      .then((res) => {
        setLoader(false);

        if (res.data.status === "success") {
          UIkit.modal("#modal-media-image").hide()
          window
            .swal({
              icon: "success",
              title: "success",
            }).then(() => summaryrefetch());

          refetch()
        }
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const completeModAL = () => {

    UIkit.modal("#modal-complete").show();
  }

  const CompleteOrder = () => {

    UIkit.modal("#modal-complete").hide();


    axios({
      method: "patch",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: { orderId: data.id, update_status: "delivered", remarks: 'order has been completed ' },
      url: Constants.url + `orders/update-status`,
    })
      .then((res) => {
        setLoader(false);

        if (res.data.status === "success") {
          window
            .swal({
              icon: "success",
              title: "success",
            }).then(() => summaryrefetch());
          refetch()

          setisDelivered(true)

        }
      })
      .catch((err) => {

        window
          .swal({
            icon: "error",
            title: "Error",
            text: err.response.data.message
          })
        // setLoader(false);
        setLoader(false);
      });

  }



  const handleDateChange = (event) => {
    const selectedDate = event.target.value; // Get selected date in 'YYYY-MM-DD' format
    const date = new Date(selectedDate);
    if (!isNaN(date)) {
      const month = date.toLocaleString('default', { month: 'long' }); // Get full month name
      const year = date.getFullYear();
      setTentativedate(`${month} ${year}`);
    }
  };

  // const customer = data.customer[0];


  const handleMarkFullPayment = () => {

    console.log(data.transaction , "transaction")
    Swal.fire({
      icon: 'warning',
      title: 'Are you sure?',
      text: 'You want to mark this order as full payment',
      showCancelButton: true,
      confirmButtonText: 'Yes, mark it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('Marking full payment...');
      }
    });
    
  }

  return (



    <div>

      {/*   Mark as Complete Order Modal   */}
      <div id="modal-complete" uk-modal="" container="#pageId">
        <CompleteModal CompleteOrder ={CompleteOrder} />
      </div>

      {/* pbo Modal  */}


      <div container="#pageId" id="modal-media-image" className="uk-flex-top" uk-modal=""  >
        <div className="uk-modal-dialog uk-width-auto uk-margin-auto-vertical">

          {PreviewPBOForm ?

            <>
              {loader ?

              <>
                    

                <div className="uk-card uk-card-default uk-width-large uk-margin-auto  uk-card-body uk-text-center" >

                  <h3 className="uk-card-title uk-text-bold uk-text-light uk-margin-small-top">
                    Sending PBO
                  </h3>

                  <div uk-spinner="" className="loader"></div>

                </div>
                </>
                :

                <>
                {/* <button className="uk-modal-close-default" type="button" uk-close>X</button> */}
                  <div ref={contentRef} className="PBO" style={{ padding: "35px" }}>
                    <div style={{ maxWidth: "1000px", margin: "0 auto", fontFamily: "sans-serif" }} className="table-responsive"    >
                      <header style={{ backgroundColor: "#000", padding: "10px", marginLeft: "5px", marginRight: "5px", }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={{ maxWidth: "40%" }}>
                            <img
                              style={{ maxWidth: "250px" }}
                              src={pbo}
                              alt=""
                            />
                          </div>
                          <div style={{ maxWidth: "60%" }}>
                            <p
                              style={{
                                color: "#fff",
                                fontSize: "16px",
                                textAlign: "right",
                                margin: "0",
                              }}
                            >
                              PROVISIONAL BOOKING ORDER (PBO) FORM
                            </p>
                          </div>
                        </div>
                      </header>
                      <div style={{ marginTop: "0" }}>
                        <table style={{ width: "100%" }}>
                          <tbody>
                            <tr>
                              <td colspan="5">MEGA MOTOR COMPANY PVT. LTD. (MMCPL )</td>
                            </tr>
                            <tr>
                              <td colspan="1">Address :</td>
                              <td colspan="3">9th Floor, Ocean Tower, Clifton, Karachi</td>
                              <td
                                colspan="2"
                                style={{
                                  backgroundColor: "#000",
                                  color: "#fff",
                                  textAlign: "center",
                                }}
                              >
                                TENTATIVE DELIVERY MONTH
                              </td>
                            </tr>
                            <tr>
                              <td colspan="1">UAN: +92 111 111 BYD (293)</td>
                              <td colspan="3">Email: customercare@byd-mega.com</td>
                              <td colspan="2" style={{ textAlign: "center" }}>

                                {Tentativedate || '-'}
                              </td>
                            </tr>
                            <tr>
                              <td colspan="1">Web Address:</td>
                              <td colspan="3">https://byd-mega.com/</td>
                            </tr>
                            <tr>
                              <td colspan="1">Booking Nr. :</td>
                              <td colspan="1">PBO-{data?.orderNo}</td>
                              <td colspan="1">DATE :</td>
                              <td colspan="1">{new Date().toLocaleString("en-US", { year: "numeric", month: "numeric", day: "numeric", hour12: true, timeZone: "UTC", })}</td>
                            </tr>
                          </tbody>  
                        </table>
                        <table style={{ width: "100%" }}>
                          <tbody>
                            <tr>
                              <td
                                colspan="7"
                                style={{ backgroundColor: "#000", color: "#fff" }}
                              >
                                1. APPLICANT DETAILS
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="place2"
                                colspan="1"
                                style={{ backgroundColor: "#fff" }}
                              >
                                1. CUSTOMER CATEGORY
                              </td>


                                {data.details.customerInfo 
                                !== null ? 
                                
                                    <td colspan="2">{data.details.customerInfo.type || '-'}</td>
                                      

                                :<td colspan="2">-</td>}
                                {/* :<td colspan="2">{data.customer.length === 0 ? '-' : data.customer[0].type}</td>} */}
                                


                              <td
                                className="place2"
                                colspan="1"
                                style={{ backgroundColor: "#fff" }}
                              >
                                2. NTN / CNIC
                              </td>


                              <td colspan="2">
                                {data.details.customerInfo.type === 'individual' ? data.details.customerInfo.cnic : data.details.customerInfo.ntn}

                              </td>


                            </tr>
                            <tr>
                              <td
                                className="place2"
                                colspan="1"
                                style={{ backgroundColor: "#fff" }}
                              >
                                3. NAME (as required to appear <br />
                                on Invoice & Sale Certificate)
                              </td>

                              {data.details.customerInfo 
                                !== null ? 
                                  <>    

                                      {data.details.customerInfo.type === 'corporate' ? 
                                      
                                      <td>{data.details.customerInfo.organizationName || '-'}</td> 
                                      
                                      :
                                      // <td colspan="8">{data.customer.length === 0 ? '-' : data.customer[0].fullname}</td>
                                      <td>{data.details.customerInfo.fullname || '-'}</td> 
                                        }
                                    </>
                                                         
                                :<td colspan="8">-</td>

                                //  <td colspan="8">{data.customer.length === 0 ? '-' : data.customer[0].type=='corporate'?data.customer[0].organizationName : data.customer[0].fullname}</td>
                              }
                              </tr>
                            <tr>
                              <td
                                className="place2"
                                colspan="1"
                                style={{ backgroundColor: "#fff" }}
                              >
                                4. FATHER'S / HUSBAND'S <br />
                                NAME (where applicable)
                              </td>
                              <td colspan="8">{data.details.customerInfo.type === 'individual' ? data.details.customerInfo.fatherName :'-'}</td>
                              {/* <td colspan="8">{data.details.customerInfo.type === 'individual' ? data.customer[0].fatherName :'-'}</td> */}
                            </tr>
                            <tr>
                              <td
                                className="place2"
                                colspan="1"
                                style={{ backgroundColor: "#fff" }}
                              >
                                4. ADDRESS
                              </td>
                              {/* <td colspan="8">{data.shipAddress.length === 0 ? '-' : data.shipAddress[0].address}, */}
                              <td colspan="8">{data.details.customerInfo.address.address || '-'},


                                 {/* {data.shipAddress.length === 0 ? '-' : data.shipAddress[0].city}, {data.shipAddress.length === 0 ? '-' : data.shipAddress[0].state}, */}
                                 {data.details.customerInfo.address? data.details.customerInfo.address.city || '-' : '-'}, {data.details.customerInfo.address.state || '-'},
                                 
                                  {/* {data.shipAddress.length === 0 ? '-' : data.shipAddress[0].country}</td> */}
                                  {data.details.customerInfo.address.country || '-'}</td>
                            </tr>
                            <tr>
                              <td
                                className="place2"
                                colspan="1"
                                style={{ backgroundColor: "#fff" }}
                              >
                                5. CITY / province
                              </td>
                              {/* <td colspan="8">{data.shipAddress.length === 0 ? '-' : data.shipAddress[0].city}, {data.shipAddress.length === 0 ? '-' : data.shipAddress[0].state}</td> */}
                              <td colspan="8">{data.details.customerInfo.address.city || '-'}, {data.details.customerInfo.address.state || '-'}</td>
                            </tr>
                            <tr>
                              <td
                                className="place2"
                                colspan="1"
                                style={{ backgroundColor: "#fff" }}
                              >
                                6. CNIC NUMBER <br /> (For end User lease/finance)
                              </td>
                              <td colspan="2">Not Applicable</td>
                              <td
                                className="place2"
                                colspan="1"
                                style={{ backgroundColor: "#fff", width: "149px" }}
                              >
                                7. D O B
                              </td>
                              {/* <td colspan="2">{data.customer.length === 0 ? '-' : data.customer[0].dob}</td> */}
                              <td colspan="2">{data.details.customerInfo.dob || '-'}</td>
                            </tr>
                            <tr>
                              <td
                                className="place2"
                                colspan="1"
                                style={{ backgroundColor: "#fff" }}
                              >
                                8. NATIONAL / TAX FREE <br /> NUMBER (for banks where <br />{" "}
                                vehicle is financed)
                              </td>
                              <td colspan="2">Not Applicable</td>
                              <td
                                className="place2"
                                colspan="1"
                                style={{ backgroundColor: "#fff", width: "149px" }}
                              >
                                9. SALES TAX REGISTRATION <br />
                                (where applicable)
                              </td>
                              {/* <td colspan="2">{data.customer.length === 0 ? '-' : data.customer[0].type === 'individual' ? 'Not Applicable' : data.customer[0].salesTax}</td> */}
                              <td colspan="2">{data.details.customerInfo.type === 'individual' ? 'Not Applicable' : data.details.customerInfo.salesTax}</td>
                            </tr>
                            <tr>
                              <td
                                className="place2"
                                colspan="1"
                                style={{ backgroundColor: "#fff" }}
                              >
                                10. PRIMARY NUMBER
                              </td>
                              {/* <td colspan="2">{data.customer.length === 0 ? '-' : data.customer[0].phone}</td> */}
                              <td colspan="2">{data.details.customerInfo.phone || '-'}</td>
                              <td
                                className="place2"
                                colspan="1"
                                style={{ backgroundColor: "#fff", width: "149px" }}
                              >
                                11. SECONDARY NUMBER
                              </td>
                              {/* <td colspan="2">{data.customer.length === 0 ? '-' : data.customer[0].secondaryPhone}</td> */}
                              <td colspan="2">{data.details.customerInfo.secondaryPhone || '-'}</td>
                            </tr>
                            <tr>
                              <td
                                className="place2"
                                colspan="1"
                                style={{ backgroundColor: "#fff" }}
                              >
                                12. NAME OF FINANCING BANK (where applicable)
                              </td>
                              <td colspan="2" className="place2">Not Applicable</td>
                              <td
                                className="place2"
                                colspan="1"
                                style={{ backgroundColor: "#fff", width: "149px" }}
                              >
                                13. Email
                              </td>
                              {/* <td colspan="2">{data.customer.length === 0 ? '-' : data.customer[0].email}</td> */}
                              <td colspan="2">{data.details.customerInfo.email || '-'}</td>
                            </tr>
                            <tr>
                              <td
                                className="place2"
                                colspan="1"
                                style={{ backgroundColor: "#fff" }}
                              >
                                14. NAME OF LESSEE <br />
                                (where applicable)
                              </td>
                              <td colspan="8">Not Applicable</td>
                            </tr>
                          </tbody>
                        </table>
                        <table style={{ width: "100%" }}>
                          <tbody>
                            <tr>
                              <td
                                colspan="8"
                                style={{ backgroundColor: "#000", color: "#fff" }}
                              >
                                2. VEHICLE DETAILS
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="place2"
                                colspan="1"
                                style={{ backgroundColor: "#fff" }}
                              >
                                Model and Variants
                              </td>
                              <td colspan="2">{data.details.variant.productName}</td>

                              <td colspan="2">{data.details.variant.variantName}</td>
                              <td colspan="2">{data.details.color.exterior.exteriorColorName}</td>
                              <td colspan="2">{data.details.color.interior.interiorColorName}</td>
                            </tr>
                            <tr>
                              <td
                                className="place2"
                                colspan="2"
                                style={{ backgroundColor: "#fff" }}
                              ></td>
                              <td
                                colspan="1"
                                style={{ backgroundColor: "#fff", textAlign: "center" }}
                              >
                                Model
                              </td>

                              <td
                                colspan="2"
                                style={{ backgroundColor: "#fff", textAlign: "center" }}
                              >
                                Variant
                              </td>
                              <td
                                colspan="2"
                                style={{ backgroundColor: "#fff", textAlign: "center" }}
                              >
                                Exterior Color
                              </td>
                              <td
                                colspan="2"
                                style={{ backgroundColor: "#fff", textAlign: "center" }}
                              >
                                Interior Color
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="place2"
                                colspan="2"
                                style={{ backgroundColor: "#fff" }}
                              >
                                Additional Services
                              </td>
                              <td colspan="8">
                                {(() => {
                                  const selectedFeatures = [];
                                  if (isChecked) selectedFeatures.push("Free 7 kW Charger Included");
                                  if (features.freeService) selectedFeatures.push("Free Service");
                                  if (features.chargingCoupons) selectedFeatures.push("Free Charging Coupons (x2)");
                                  if (features.chargerInstallation) selectedFeatures.push("Free Charger Installation");
                                  if (features.extendedWarranty) selectedFeatures.push("Extended Warranty on Low Voltage LFP Battery (10 years)");
                                  if (features.atto2LimitedOffer) selectedFeatures.push("Atto 2 Limited Time Offer");
                                  if (features.sealion7LimitedOffer) selectedFeatures.push("Sealion 7 Limited Time Offer");
                                  return selectedFeatures.length > 0 ? selectedFeatures.join(", ") : "Not Applicable";
                                })()}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="place2"
                                colspan="2"
                                style={{
                                  backgroundColor: "#fff",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                }}
                              >
                                Pricing
                              </td>
                              <td colspan="8" style={{ backgroundColor: "#fff" }}></td>
                            </tr>
                            <tr>
                              <td
                                className="place2"
                                colspan="2"
                                style={{ backgroundColor: "#fff" }}
                              >
                                Company Price
                              </td>
                              <td colspan="2">Rs. {((data.details.variant.variantPrice) + (data.details.variant.colorComboPrice)).toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}/-</td>
                            </tr>
                            <tr>
                              <td
                                className="place2"
                                colspan="2"
                                style={{ backgroundColor: "#fff" }}
                              >
                                Freight / Insurance
                              </td>
                              <td colspan="2">{data.details.vehicleDelivery?.freightCharges ? data.details.vehicleDelivery?.freightCharges : "-"}</td>
                            </tr>
                            <tr>
                              <td
                                className="place2"
                                colspan="2"
                                style={{ backgroundColor: "#fff" }}
                              >
                                WHT
                              </td>
                              <td colspan="2">Not Applicable</td>
                            </tr>
                            <tr>
                              <td
                                className="place2"
                                colspan="2"
                                style={{ backgroundColor: "#fff" }}
                              >
                                Gross Price
                              </td>
                              <td colspan="2">Rs. {((data.details.variant.variantPrice) + (data.details.variant.colorComboPrice) + (data.details.vehicleDelivery?.freightCharges)).toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}/-</td>
                            </tr>
                          </tbody>
                        </table>
                        <table style={{ width: "100%" }}>
                          <tbody>
                            <tr>
                              <td
                                colspan="8"
                                style={{ backgroundColor: "#000", color: "#fff" }}
                              >
                                3. PAYMENT/PURCHASE ORDER DETAILS
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="place2"
                                colspan="1"
                                style={{ backgroundColor: "#fff" }}
                              >
                                PAYMENT
                              </td>
                              <td colspan="8" style={{ backgroundColor: "#fff" }}>
                                <div
                                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                                >
                                  <input
                                    type="checkbox"
                                    checked
                                    style={{ width: "20px", height: "20px" }}
                                  />{" "}
                                  <span>Advance Booking / Partial Payment</span>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="1" style={{ textAlign: "center" }}>
                                Type
                              </td>
                              <td colspan="1" style={{ textAlign: "center" }}>
                                Instrument
                              </td>
                              <td colspan="1" style={{ textAlign: "center" }}>
                                Number
                              </td>
                              <td colspan="1" style={{ textAlign: "center" }}>
                                Date
                              </td>
                              <td colspan="1" style={{ textAlign: "center" }}>
                                Bank
                              </td>
                              <td colspan="1" style={{ textAlign: "center" }}>
                                Amount
                              </td>
                            </tr>


                            

                            {data.transaction.map((transaction, index) => (
                                    transaction.status === 'Paid' && ( // Only render the row if  transaction.status === 'Paid'
                                      <tr key={index}>
                                        <td colSpan="1" style={{ textAlign: "center" }}>
                                          PARTIAL
                                        </td>

                                        <td colSpan="1" style={{ textAlign: "center" }}>
                                          {data.transaction.length === 0
                                            ? '-'
                                            : data.transaction[0].paymentType === 'Dealer'
                                            ? 'Pay Order via Bank'
                                            : 'Pay Pro'}
                                        </td>

                                        <td colSpan="1" style={{ textAlign: "center" }}>
                                          {transaction.referenceId || '-'}
                                        </td>

                                        <td colSpan="1" style={{ textAlign: "center" }}>
                                          {data.transaction.length === 0
                                            ? '-'
                                            : data.transaction[0].paymentDate
                                            ? new Date(transaction.paymentDate).toLocaleString("en-US", {
                                                year: "numeric",
                                                month: "numeric",
                                                day: "numeric",
                                              })
                                            : '-'}
                                        </td>

                                        <td colSpan="1" style={{ textAlign: "center" }}>
                                          {data.transaction.length === 0
                                            ? '-'
                                            : data.transaction[0].paymentType === 'PayPro'
                                            ? '-'
                                            : data.banks.name}
                                        </td>

                                        <td colSpan="1" style={{ textAlign: "center" }}>
                                          Rs. {transaction.amount
                                            .toString()
                                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}/-
                                        </td>
                                      </tr>
                                    )
                                  ))}





                              {/* <tr>
                              <td colspan="1" style={{ textAlign: "center" }}>
                                PARTIAL
                              </td>

                              <td colspan="1" style={{ textAlign: "center" }}>{data.transaction.length === 0 ? '-' : data.transaction[0].paymentType === 'Dealer' ? 'Pay Order via Bank' : 'Pay Pro'}</td>
                              <td colspan="1" style={{ textAlign: "center" }}>{data.transaction.length === 0 ? '-' : data.transaction[0].referenceId}</td>
                              <td colspan="1" style={{ textAlign: "center" }}>{data.transaction.length === 0 ? '-' : data.transaction[0].paymentDate
                                ? new Date(data.transaction[0].paymentDate).toLocaleString("en-US", { year: "numeric", month: "numeric", day: "numeric" })
                                : "-"}</td>
                              <td colspan="1" style={{ textAlign: "center" }}>{data.transaction.length === 0 ? '-' : data.transaction[0].paymentType === 'PayPro' ? '-' : data.banks.name}</td>
                              
                              <td colspan="1" style={{ textAlign: "center" }}>Rs. {transactionAmount().toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}/-
                              </td>
                            </tr> */}






                            <tr>
                              {/* <td
                            className="place2"
                            colspan="1"
                            style={{ backgroundColor: "#fff", width: "149px" }}
                          >
                            Total Amount in Words
                          </td>
                          <td colspan="8">{numberToWords(data.details.variant.variantPrice + data.details.variant.colorComboPrice)}</td> */}
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        style={{ marginTop: "10px", padding: "15px 10px 15px 10px", backgroundColor: "#000" }}
                      >
                        <h3 style={{ color: "#fff", fontSize: "16px", marginBottom: "2px" }}>
                          DECLARATION
                        </h3>
                        <p style={{ color: "#fff", fontSize: "12px", lineHeight: "18px" }}>
                          I confirm that I have read and understood all the terms and conditions and accept them before proceeding with my online booking.  (including, without limitation, clause 4 section (iv), relating to the payment of price as finally fixed at the time of delivery by the Company while taking into account any reasons or circumstances it may regard as relevant or applicable, such as official levies, currency fluctuations etc.). The PBO will be deemed cancelled if payment is not received by the Mega Motor Company (Private) Limited.
                        </p>
                      </div>
                      <div style={{ marginTop: "6px", width: "50%" }} className="sign">
                        {/* <hr /> */}
                        <p
                          style={{
                            color: "#000",
                            fontSize: "12px",
                            lineHeight: "18px",
                            marginTop: "5px",

                          }}
                        >
                          This is a computer-generated document. No signature is required
                        </p>
                      </div>
                    </div>
                    <div className="pbo-page-break"></div>
                    {showspace ? <><br /> <br /><br /> <br /> <br /><br /><br /><br /><br /><br /><br /><br /></> : <div></div>}
                    <div style={{ maxWidth: "1000px", margin: "0 auto", fontFamily: "sans-serif", paddingRight:"10px" }} className="table-responsive"    >
                      <div style={{ marginTop: "60px" }}>
                        
                        
                        <h3 style={{ color: "#000", fontSize: "16px", textAlign: "center", marginTop: "50px" }}>
                          Terms and Conditions
                        </h3>
                        <ul style={{ marginTop: "30px" }} className="terms">
                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000" }}>
                            This Provisional Booking Order <strong>(“PBO”)</strong> is issued by the MEGA MOTOR COMPANY (PRIVATE) LIMITED
                            <strong> (“Company”)</strong> . The term <strong>“Applicant”</strong>  wherever used shall mean an individual or a company who has applied for
                            booking of a BYD Vehicle. The term <strong>“Vehicle”</strong>  shall mean the Completely Built-up Units offered by the Company
                            and includes the optional items, accessories and other articles offered/supplied with the motor vehicle at the
                            time of delivery.
                          </li>
                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000"  }}>
                            This PBO is subject to confirmation by the Company and shall only become effective thereafter.
                          </li>
                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000"  }}>
                            The Company may without notice make alterations to the design and construction specification of the Vehicle,
                            and/or such alterations in the Vehicle as required by any Federal and/or Provincial legislation. The Company may
                            without notice make amendments to the delivery schedule of the Vehicle and may alter the price of the Vehicle
                            on account of government taxes and/or levies and/or currency fluctuations, or any other reason, such change
                            being outside the reasonable control of the Company, which revisions in price shall be borne by the Applicant.
                            The Company may also transfer this PBO to another Authorized Dealer without assigning any reason to the
                            Applicant and the Vehicle may be supplied with or without such alterations and change through any Authorized
                            Dealer.
                          </li>
                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000"  }}>
                            <ul>
                              <li style={{ listStyle: "none" }}>
                                i. The price(s) indicated/advertised are tentative Company prices inclusive of sales tax (excluding other levies
                                and costs, government and local taxes) <strong>(the “Price”)</strong>.
                              </li>
                              <li style={{ listStyle: "none" }}>
                                ii. The Applicant shall deposit with the Company an advance or full payment of
                                    Price in the form of a pay order, demand draft or online payment in the name of
                                    the Company.
                              </li>
                              <li style={{ listStyle: "none" }}>
                                iii. The remaining amount (if applicable) of the Price shall be paid to the Company
                                      prior to the delivery date of the Vehicle. In case the Applicant fails to make
                                      payment of the remaining amount of the Price  (as applicable), the Company
                                      reserves the right to cancel the order and shall refund the amount paid by the
                                      Applicant, less an administrative charge equivalent to 5% of the Price, excluding
                                      sales tax deposited on behalf of the Applicant.
                              </li>
                              <li style={{ listStyle: "none" }}>
                                iv. The Price prevailing as at the time of delivery of the Vehicle will be the applicable Price to be paid by the
                                Applicant.
                              </li>
                              <li style={{ listStyle: "none" }}>
                                v. The Vehicle shall not be delivered to the Applicant until and unless the Company
                                    receives the entire payment of the Price. In the event that the Vehicle is ready to
                                    be delivered and the Applicant delays the payment of the remaining amount of the
                                    Price (as applicable) to the Company, or does not take delivery of the Vehicle, the
                                    Company will hold the Vehicle for fifteen (15) days after the delivery date of the
                                    Vehicle and thereafter deal with the Vehicle in the manner deemed fit by the
                                    Company. Any unforeseen damage suffered by the Vehicle during this period will
                                    be the sole responsibility of the Applicant.
                              </li>

                              <li style={{ listStyle: "none" }}>
                                vi. If the Applicant wishes, at any time before the delivery of the Vehicle, to cancel the booking under the PBO,
                                the Applicant may do so by making a written application (accompanied by the Applicant’s copy of the
                                computer generated PBO) to the Company. The Company shall refund the amount paid by the Applicant,
                                less an administrative charge equivalent to 5% of the Price, excluding sales tax deposited on behalf of the Applicant. The net amount shall be paid to the Applicant by
                                means of a crossed cheque in the name of the Applicant within thirty (30) days of the date of receipt of the
                                Applicant’s written application by the Company for cancellation of the PBO. The Company reserves the right
                                to refuse any application for cancellation which is not accompanied by the Applicant’s copy of the computer
                                generated PBO.
                              </li>
                            </ul>
                          </li>
                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000"  }}>
                            The Authorized Dealer and the Company shall make reasonable endeavors to deliver the Vehicle by the tentative
                            delivery date, but shall not be responsible for any delays in the delivery of the Vehicle, including but not limited
                            to, any delays occurring due to acts of God or enemy, change in government policies, labor strikes or civil
                            commotion, injunctions granted by courts of law, or for any other reason beyond the reasonable control of either
                            the Authorized Dealer or the Company.
                          </li>
                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000"  }}>
                            No delivery shall be made of the Vehicle unless at the time of delivery, the Applicant has a copy of the computer
                            generated PBO, which shall be surrendered to the Company through the Authorized Dealer at the time of
                            delivery.
                          </li>
                          {/* <div style={{pageBreakAfter:"always"}}></div> */}

                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000"  }}>
                            The information provided by the Applicant has been provided on his/her own responsibility and without any
                            verification by the Company or obligation on the Company to verify the same. The Company is and shall be
                            entitled to consider the information provided as true and correct to the best of the Applicant’s knowledge and
                            sufficient for all purposes, including but not limited to, the purposes of correspondence/ communication with
                            the Applicant. Any notices/letters sent at the given address shall be deemed to have been delivered in due course
                            of post. Non-receipt of letters, correspondence and communication shall not be considered an excuse for delay
                            in payment. Incomplete or incorrect forms may be rejected at the sole discretion of the Company.
                          </li>
                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000"  }}>
                            No request for change of name shall be entertained.
                          </li>
                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000"  }}>
                            In the case of any dispute between the Applicant and the Company, the matter will be brought to an amicable
                            settlement between the parties. In the event of no satisfactory settlement being reached, it is agreed that the
                            dispute, controversy or difference shall be finally settled by arbitrators, one appointed by each party, in
                            accordance with the Arbitration Act 1940 of Pakistan. The seat of arbitration shall be Karachi. The language to
                            be used in the arbitration shall be English.
                          </li>

                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000"  }}>
                            Notwithstanding the above, the Company shall have recourse to any court of competent jurisdiction in the event
                            of a dispute, if it so deems necessary for injunctive relief or specific performance of the PBO.
                          </li>
                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000"  }}>
                            The Applicant agrees and undertakes to pay taxes, fees and other charges etc. or any other levy of whatsoever
                            nature as may be levied from time to time by any government authority, local body or other organization or
                            agency at the time of the delivery of the Vehicle or otherwise. All such amounts as aforesaid shall be paid as and
                            when indicated by the Company and the Company's communication in this regard shall be conclusive and binding
                            on the Applicant. The status of the Applicant at the time of invoicing shall be used to determine the final
                            payment.
                          </li>
                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000"  }}>
                            Delay in taking delivery on account of wrong/incomplete address recorded with the Company or change of
                            address not intimated to the Company in time or due to any other reason whatsoever will be entirely at the
                            Applicant's risk, expense and responsibility.
                          </li>
                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000"  }}>
                            The Applicant hereby understands and acknowledges that the Authorized Dealers are not the agents, personnel
                            or representatives of the Company. The actions and/or representations of the Authorized Dealers shall not, in
                            any future/subsequent correspondence/communication with the Applicant, bind the Company in any manner
                            whatsoever.
                          </li>
                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000"  }}>
                            By accepting this PBO, the Applicant hereby represents and warrants that the information provided herein is
                            true and correct to the best of the Applicant’s knowledge and that the Company may rely on such information
                            when processing and/or completing the Applicant’s order. The Applicant accepts, however, that in case any of
                            the information/data provided by the Applicant is false, incorrect or misleading in any manner whatsoever, the
                            Company has the right to immediately cancel/withdraw the PBO, without any prior notice or intimation, and
                            claim damages from the Applicant, if deemed appropriate by the Company.
                          </li>
                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000"  }}>
                            Upon delivery of the Vehicle the Applicant shall sign a delivery acceptance form. Vehicle once delivered to the
                            Applicant shall not be returned to the Company, for any reason or under any circumstances whatsoever. After
                            delivery, the Company will be indemnified against all damages and/or defects found in the Vehicle by any
                            Applicant except to the extent covered by the Company’s standard warranty provided to the Applicant by the
                            Company for the Vehicle.
                          </li>
                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000"  }}>
                            Request for variant and color change after booking of the Vehicle can only be entertained subject to availability
                            of vehicle.
                          </li>
                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000"  }}>
                            The personal information provided by the Applicant, may be collected and stored by the Company on its
                            database and used for the purposes of data collection of its customers. The Company reserves the right to
                            disclose such information to third parties as necessary to fulfill its obligations or as required by the law. With
                            respect to the collection and use of the aforementioned data, the Company shall comply with all applicable data
                            privacy laws of Pakistan.
                          </li>
                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000"  }}>
                            The Applicant agrees to indemnify and hold the Company harmless from any liability if the Vehicle can no longer
                            be supplied due to the discontinuation of the specific model by the manufacturer. In such cases, the Company,
                            shall only be required to notify the Applicant and process any refund as per other terms of this PBO.
                          </li>
                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000"  }}>
                            The Applicant has read, understood and accepted the terms and conditions contained herein.
                          </li>
                          <li style={{ listStyle: "decimal", marginBottom: "15px", fontSize: "10px", color:"#000"  }}>
                            The Company’s interpretation of the PBO and the terms and conditions contained herein shall be final and
                            binding. The Company reserves the right to change Prices and to alter the terms and conditions of this PBO at its
                            sole and absolute discretion.
                          </li>
                        </ul>
                      </div>
                      <div style={{ marginTop: "30px", width: "15%" }} className="terms">
                        {/* <hr /> */}
                        {/* <p
                    style={{
                      color: "#000",
                      fontSize: "12px",
                      lineHeight: "18px",
                      marginTop: "5px",
                    }}
                  >
                    Applicant Signature
                  </p> */}
                      </div>
                    </div>
                  </div>
                  <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                    <center><button className=" uk-button uk-button-primary" onClick={() => generateMultiPagePDF()}>Generate PBO</button></center>
                  </div>
                </>
              }

            </>

            :

            <>

              {/* Tentative Date Selector */}

              <div className="uk-card uk-card-default uk-card-body uk-width-large uk-margin-auto uk-text-center">
                <button className="uk-modal-close-default" type="button" uk-close>
                  X
                </button>
                <h3 className="uk-card-title uk-text-bold uk-text-light uk-margin-small-top">
                  Select Tentative Date
                </h3>
                <div className="uk-margin">
                  <input className="uk-input uk-form-width-medium" type="month" onChange={(e) => handleDateChange(e)} />
                </div>
                <div className="uk-margin uk-flex uk-flex-between uk-flex-middle">
                  <span>Include 7 kW Charger: </span>
                  <input type="checkbox" style={{ width: "20px", height: "20px" }} checked={isChecked} onChange={(e) => handleCheckboxChange(e)}/>
                </div>
                <div className="uk-margin uk-flex uk-flex-between uk-flex-middle">
                  <span>Include Free Service: </span>
                  <input type="checkbox" style={{ width: "20px", height: "20px" }} checked={features.freeService} onChange={handleFeatureChange('freeService')}/>
                </div>
                <div className="uk-margin uk-flex uk-flex-between uk-flex-middle">
                  <span>Free Charging Coupons (x2): </span>
                  <input type="checkbox" style={{ width: "20px", height: "20px" }} checked={features.chargingCoupons} onChange={handleFeatureChange('chargingCoupons')}/>
                </div>
                <div className="uk-margin uk-flex uk-flex-between uk-flex-middle">
                  <span>Free Charger Installation:</span>
                  <input type="checkbox" style={{ width: "20px", height: "20px" }} checked={features.chargerInstallation} onChange={handleFeatureChange('chargerInstallation')}/>
                </div>
                <div className="uk-margin uk-flex uk-flex-between uk-flex-middle">
                  <span className="uk-text-left">Extended Warranty on Low Voltage LFP Battery (10 years): </span>
                  <input type="checkbox" style={{ width: "20px", height: "20px" }} checked={features.extendedWarranty} onChange={handleFeatureChange('extendedWarranty')}/>
                </div>
                <div className="uk-margin uk-flex uk-flex-between uk-flex-middle">
                  <span>Atto 2 Limited Time Offer: </span>
                  <input type="checkbox" style={{ width: "20px", height: "20px" }} checked={features.atto2LimitedOffer} onChange={handleFeatureChange('atto2LimitedOffer')}/>
                </div>
                <div className="uk-margin uk-flex uk-flex-between uk-flex-middle">
                  <span>Sealion 7 Limited Time Offer: </span>
                  <input type="checkbox" style={{ width: "20px", height: "20px" }} checked={features.sealion7LimitedOffer} onChange={handleFeatureChange('sealion7LimitedOffer')}/>
                </div>
                <div className="uk-margin">
                  <button className=" uk-button uk-button-primary " onClick={clickToViewPreviewPBOForm} disabled={!Tentativedate} >Preview PBO Form</button>
                </div>
              </div>
            </>

          }


        </div>
      </div>








      {/* Update Info Modal  */}
      <div id="details" uk-modal="" container="#pageId">
        <div className="uk-modal-dialog uk-modal-body uk-card uk-card-default uk-card-hover "   style = {{width:'800px'}} >
          <button className="uk-modal-close-default" type="button" uk-close>
            X
          </button>

          <h3 className="uk-text-bold uk-text-light uk-text-center">
            Edit Customer Details
          </h3>

          <EditModal customerDetails={customer} id={data.id} customerData={customerData} setCustomerData={setCustomerData} refetch={refetch} />
        </div>
      </div>





      <div
        id="update_status"
        container="#pageId"
        uk-modal=""
        style={{ paddingTop: "180px" }}
      >
        <div className="uk-modal-dialog uk-modal-body uk-card uk-card-default uk-card-hover uk-width-large ">
          <button className="uk-modal-close-default" type="button" uk-close>
            X
          </button>

          <h3 className="uk-text-bold uk-text-light">Update Status</h3>

          <form
            className="uk-form-stacked uk-padding "
            onSubmit={handleSubmit(Submit)}
          >
            <div className="uk-margin-small">
              <label className="uk-form-label">
                Status
              </label>

              <select
                {...register("update_status", { required: "Field is required" })}
              >
                <option value="">Select Status</option>{" "}
                {/* Add a default option */}
                <option value="awaiting-assignee">Awaiting Assignee</option>
                {user.role === 'dealer' ? '' : <option value="approved">Approved</option>}
                {user.role === 'dealer' ? '' : <option value="dispatched">Dispatched</option>}
                {user.role === 'dealer' ? '' : <option value="cancelled">Cancelled</option>}
              </select>
            </div>

            <div className=" uk-width-1-1  uk-margin-small uk-flex uk-flex-center">
              <textarea className=" uk-textarea uk-width-1-1" placeholder="Write Remarks" {...register("remarks", { required: "Field is required" })}></textarea>
            </div>

            <div className="uk-margin-small uk-flex uk-flex-center">
              
              <button
                className="uk-button uk-button-secondary uk-button-medium uk-width-1-1"
                type="submit"
              >
                {loader ? <div uk-spinner="" className="loader"></div> : "Update"}
              </button>
            </div>
          </form>
        </div>
      </div>

      
      <div
        className = 'uk-modal'
        id= {`generate_invoice${data.id}`}
        container="#pageId"
        uk-modal="true"
        
      >
          
        <InvoiceModal data = {data}  loader={loader} slipType={invoiceType} />
          
      </div>


      {/* ============================= */}






      <div
        className="uk-grid uk-padding drpdwn "
        uk-grid=""
        style={{ margin: 0 }}
      >






        <div className="uk-width-1-4" style = {{background :''}} >




          <div className="uk-flex uk-flex-between">


                    <h4>Customer Details</h4>{" "}



                  {
                    user.role !== 'viewer' && Permissions.includes('oms-update-status') ?
                    
                    <>
                    {data.paymentStatus !== "incart" ? 
                    <a
                      className="uk-link-heading"
                      onClick={() => openModal()}
                      style={{ paddingRight: "10px" }}
                    >
                      Edit
                    </a>
                    : ''} 
                    </>

                    : ''}

                  
          </div>


          <div className="uk-grid dropcontent" uk-grid="">


            <ul className="uk-list" >
                
                <li>
                  <h3>Full Name</h3> <p>{customerData.fullname || "-"}</p>
                </li>


                <li>
                  <h3>Father/Husband Name</h3> <p>{customerData.fatherName || "-"}</p>
                </li>



                {customerData.type === 'individual' ?    
                ''   
                :

                <li>
                  <h3 className="">Organization Name</h3> <p className="uk-text-break detailaddress" >{customerData.organizationName || "-"} </p>
                </li>
                
                
                }




                <li>
                  <h3>Gender</h3> <p>{customerData.gender || "-"}</p>
                </li>
                <li>
                  <h3>Type</h3> <p>{customerData.type || "-"}</p>
                </li>
                <li>
                  <h3>City</h3> <p>{customerData.address? customerData.address.city || "-" : '-'}</p>
                </li>
                <li>
                  <h3>State</h3> <p>{customerData.address ?customerData.address.state || "-" :'-'}</p>
                </li>
                <li>
                  <h3>Email Address</h3> <p>{customerData.email || "-"}</p>
                </li>

                
               
              </ul>
              
              
            <ul className="uk-list" >


            


            <li>
                  <h3>Date of Birth</h3> <p>{customerData.dob || "-"}</p>
                </li>
               
            <li>
                  <h3>Phone Number</h3> <p>{customerData.phone || "-"}</p>
                </li>
                <li>
                  <h3>Secondary Phone</h3> <p>{customerData.secondaryPhone || "-"}</p>
                </li>
                <li  >
                  <h3  >Address as per CNIC</h3> <p className = ' detailaddress uk-text-break'>{customerData.address? customerData.address.address || "-" : '-'}</p>
                </li>
                {/* <li>
                    <h3>Address</h3> <p>{customerData.address}</p>
                  </li> */}
                <li>
                  <h3>CNIC</h3> <p>{customerData.cnic || "-"}</p>
                </li>


                {customerData.type === 'corporate' ?    
                   
                <li>
                  <h3>ntn</h3> <p>{customerData.ntn || "-"}</p>
                </li>
                :
                  ''
                
                
                }

                <li>
                    <h3>Vehicle Delivery Detail</h3> <p>{data.details.vehicleDelivery.name}</p>
                  </li>
                
            </ul>  




              

          </div>
        </div>







        <div className="uk-width-expand">
          <div className="analyticsContainer formCentralContainer">
            <ul
              className="uk-subnav uk-subnav-pill"
              uk-switcher="connect: #subTabs"
            >
              <li>
                <a>Split Orders</a>
              </li>
              <li>
                <a>Transaction Details</a>
              </li>
              <li>
                <a>Comments</a>
              </li>
              <li>
                <a>Order log</a>
              </li>
              <li>
                <a>Documents</a>
              </li>
            </ul>

            <div className="tabContent   "> 
              <ul className="uk-switcher uk-margin" id="subTabs">
                <li>
                  <SplitOrder data={data.details} />
                </li>
                <li>
                  <Transaction status ={data.paymentStatus}  data={data.transaction} id={data.id} refetch = {refetch} />
                </li>
                <li>
                  <Comments   refetch={refetch} status ={data.paymentStatus}  data={data.comments} id={data.id} />
                </li>
                <li>
                  <Orderlogs status={data.history} />
                </li>
                <li>
                  <Documents  status ={data.paymentStatus} data={data.orderPaymentDocuments} id={data.id} />

                </li>
              </ul>
            </div>

            <div className="uk-margin-top">
              <SumTable data={data} />
            </div>

            <div className="    dropdwnbtns right uk-width-1-1 uk-padding-small ">


              {/* if Payment Status is Incart User Dont have access to any buttons */}


              {/* if pbo is not generated , already has invoice , not in awaiting asignee then the generate invoice button will not show  */}

              {Permissions?.includes("oms-update-status") && (
               (!hasPboDocument || hasInvoiceDocument || data.paymentStatus !== "awaiting-assignee" )? 
              
              ''
              : 
              <button className=" uk-button uk-button-primary " disabled={(isDelivered)} onClick={() => { setInvoiceType('final'); UIkit.modal(`#generate_invoice${data.id}`).show();}} >
              Final Payment Slip
            </button>                                      
              )}


              { Permissions?.includes("oms-full-payment") && data.transaction.length === 0 && data.paymentStatus === "pending-dealership" && !hasFullPaymentSlipDocument ? 
              
              <button className=" uk-button uk-button-secondary " disabled={(isDelivered)} onClick={() => { setInvoiceType('full'); UIkit.modal(`#generate_invoice${data.id}`).show();}} >
              Full Payment Slip
            </button>
              :
              ''
              }



              


             {Permissions?.includes("oms-update-status") && (
              ( user.role === 'viewer'|| user.role === 'dealer' || hasPboDocument || data.paymentStatus !== "awaiting-assignee" ||data.paymentStatus === "incart" ) ? '' : <button className=" uk-button uk-button-primary " onClick={openPdf} disabled={(isDelivered)} >
                Generate PBO
              </button>
              )}

              {Permissions?.includes("oms-update-status") && (
                (data.paymentStatus === "incart" || user.role === 'viewer') ? '' :
                  <button disabled={isDelivered} className=" uk-button uk-button-primary " onClick={openUpdateStatusModal}>
                    Update Status
                  </button>
              )
              }

              {Permissions?.includes("oms-update-status") && (
               ( user.role === 'viewer' || user.role === 'dealer' || data.paymentStatus === "incart") ?'' : <button
                onClick={completeModAL}
                className="uk-button uk-button-primary"
                style={{ background: "rgb(0 211 0)" }}
                disabled={isDelivered}
              >
                Mark As Complete
              </button>
              )}

              <button
                className=" uk-button uk-button-danger"
                style={{ background: '#bb0a0ae0' }}
                onClick={closeFunc}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dropdown;
